import { useContext } from "react";
import { MapFiltersContext } from "../contexts/MapFiltersContext";

function useMapFilters() {
    return useContext(MapFiltersContext);
}

export default useMapFilters